export function findNotification(state) {
  return (id) => state.all.find(((v) => v.id === id));
}
